export const styles = {
  smallSpinner: {
    marginRight: '.4rem',
  },
};
